import { render } from "./SeleccionarPedidosRecepcionComponent.vue?vue&type=template&id=15504e2a&scoped=true"
import script from "./SeleccionarPedidosRecepcionComponent.vue?vue&type=script&lang=js"
export * from "./SeleccionarPedidosRecepcionComponent.vue?vue&type=script&lang=js"

import "./SeleccionarPedidosRecepcionComponent.vue?vue&type=style&index=0&id=15504e2a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15504e2a"]])

export default __exports__